import React from 'react'

import { useAppSelector } from 'reduxTyped'
import { getAddOnsData } from 'common/billing/entities/addOns/selectors'
import { getActiveProProducts } from 'common/billing/entities/pro/selectors'
import { ProductSlugToTypeMap } from 'common/billing/entities/pro/utils/ProductSlugToTypeMap'

import { SubscriptionElement } from './components/SubscriptionElement'
import { getSubscriptionElementPropsByType } from './helpers'

export const SubscriptionList = () => {
  const activePlans = useAppSelector(getActiveProProducts)
  const addOns = useAppSelector(getAddOnsData)
  const products = [
    ...activePlans.map((plan) => ({ type: ProductSlugToTypeMap[plan] })),
    ...addOns.map((addOn) => ({ type: addOn.slug })),
  ]

  return (
    <div className="d-flex gap-x-xs p-a-xs flex-wrap">
      {products.map((product) => {
        const props = getSubscriptionElementPropsByType(product.type)

        if (!props) {
          return null
        }

        return <SubscriptionElement {...props} />
      })}
    </div>
  )
}
